import config from '../config/index'
import { authRequest } from '../request'
import { IStudioAreaUserDto } from '../share-types'

const { mainApi } = config

export const getStudioAdminUserInfo = () =>
  authRequest.get<MISSING_TYPE, IStudioAreaUserDto>(`${mainApi}/studios-area/user-info`)
